/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const ALLOWED_ATTRIBUTES = {"a":["href","rel","target"]};
export const ALLOWED_TAGS = ["a","br","em","li","p","ol","strong","ul"];
